<app-point
  [data]="p"
  *ngFor="let p of points; trackBy: trackByFn"
  [area]="area"
  [streamId]="stream.id"
  (destroyed)="pointerDestroyed($event)"
></app-point>
